export const PortFolioData = [

    {
        projectname: "FlashSites CDN — Control Plane",
        startDate: null,
        endData: null,
        techstacks: ['TypeScript', 'Node.js', 'gRPC', 'Redis Streams', 'PostgreSQL', 'HashiCorp Vault', 'Envoy', 'GCP', 'Docker'],
        description: `
            Control plane for a multi-region content delivery network that configures and coordinates
            globally distributed edge points-of-presence (PoPs). A two-tier Global↔Regional control plane
            pushes per-tenant edge configuration, TLS certificates and cache-replication policy to every
            region and keeps them consistent — so a config change, cert rotation or purge applies exactly
            once across all PoPs, and any region can rehydrate its full state after a restart.<br/>
            Built intent-based orchestration over Redis Streams with idempotent, exactly-once task semantics;
            tenant config compiled to FlatBuffers and distributed via Redis; certificate keys
            envelope-encrypted with HashiCorp Vault Transit (KMS); DNS-based domain-ownership verification;
            and gRPC / Envoy xDS+SDS for edge delivery.
        `,
        github: null,
        repoType: "private",
        livelink: ""
    },
    {
        projectname: "Collabry",
        startDate: null,
        endData: null,
        techstacks: ['React', 'Vite', 'TypeScript', 'Node.js', 'Express', 'PostgreSQL', 'Razorpay', 'Firebase'],
        description: `
            A two-sided influencer-marketing marketplace connecting Indian brands with content creators for
            paid campaigns, product-barter deals and direct collaborations. Handles the full deal lifecycle —
            proposal, negotiation, escrowed Razorpay payments, shipping, content review, dispute resolution
            and creator payouts — with an admin console, a 98-template transactional email pipeline and
            real-time in-app + push notifications. Built as a pnpm monorepo and deployed to a self-hosted VPS
            via GitHub Actions.
        `,
        github: null,
        repoType: "private",
        livelink: "https://collabry.co"
    },
    {
        projectname: "Forge — Product & Project Platform",
        startDate: null,
        endData: null,
        techstacks: ['Rust', 'Axum', 'React', 'PostgreSQL', 'Keycloak', 'Redis', 'MinIO', 'Stripe', 'Docker'],
        description: `
            Unifies the full product lifecycle in one platform — Kanban boards, a research module (personas,
            problem statements, workflows), a risk register, time logging, velocity analytics and Stripe
            billing — with real-time multi-user collaboration (live cursors, instant board updates) under one
            login. Replaced a legacy Java/Spring Boot monolith by rewriting the backend to Rust
            (Axum + SQLx + Tokio) for memory safety and performance under concurrent WebSocket load, keeping
            the REST/WebSocket contract intact so the React frontend needed no changes. Auth is centralized in
            Keycloak (OIDC/JWT), and the whole six-service stack ships as one all-in-one Docker image that
            runs from a single docker run.
        `,
        github: null,
        repoType: "private",
        livelink: ""
    },
    {
        projectname: "BackpackLink",
        startDate: null,
        endData: null,
        techstacks: ['TypeScript', 'Next.js', 'Express', 'Prisma', 'Flutter', 'Stripe', 'Socket.IO', 'Dart'],
        description: `
            A cross-platform travel-eSIM marketplace — a branded iOS + web storefront sitting on top of a
            wholesale eSIM provider. It applies its own pricing and lets travelers search a destination, pay
            by card and receive a QR code that puts them online the moment they land, all while their normal
            number keeps working. Built as a TypeScript + Dart monorepo: an Express/Prisma API, two Next.js 15
            frontends (customer storefront + operations admin) and a Flutter iOS app — integrated with the
            provider's API for provisioning and live usage, Stripe for checkout and socket.io for real-time
            support chat. Carried through full App Store readiness with self-hosted CI/CD that auto-deploys on
            every push.
        `,
        github: null,
        repoType: "private",
        livelink: "https://www.backpacklink.com"
    },
    {
        projectname: "RichBengali",
        startDate: null,
        endData: null,
        techstacks: ['Flutter', 'Dart', 'Agora RTC', 'Socket.IO', 'CallKit', 'FCM', 'Riverpod', 'Sentry'],
        description: `
            A cross-platform dating and social-connection app for the Bengali/Bangladeshi market that turns
            real-time conversation into a creator economy — users discover people, chat instantly and connect
            over live audio/video calls, where female creators earn per minute of call time and male users pay
            from a wallet balance.<br/>
            Built end to end in Flutter: real-time messaging over Socket.IO and low-latency calling with Agora
            RTC (in-call beauty filters and virtual backgrounds), plus native incoming-call experiences — iOS
            CallKit with PushKit VoIP push and Android ConnectionService with FCM — so calls ring natively even
            when the app is closed. Implemented per-minute live-earnings, wallet and withdrawal/payout flows for
            local methods (bKash and bank transfer), and hardened for production with Sentry, secure storage,
            anti-screenshot protection and Riverpod. Owned the full release pipeline across iOS code signing,
            App Store Connect/TestFlight and Android release builds.
        `,
        github: null,
        repoType: "private",
        livelink: "https://richbengali.com"
    },
    {
        projectname: "FlashSites Web Analysis",
        startDate: "01/07/2024",
        endData: null,
        techstacks: ['Python', 'ReactJs', 'NLP', 'SEO Automation'],
        description: `
            An AI-assisted automation system that crawls websites, evaluates content quality using NLP
            and generates SEO-optimization reports. I built both the Python analysis pipeline and the
            React interface used to review and export the generated reports.
        `,
        github: null,
        repoType: "private",
        livelink: "https://flashsites.de"
    },
    {
        projectname: "OneTeam (Contractual)",
        startDate: "02/12/2022",
        endData: "21/02/2023",
        techstacks: ['NodeJS', 'Spring-boot', 'ReactJS (SSR)', 'PostgreSql', 'Jest', 'Azure'],
        description: `
            A project management platform with Kanban-style workflows — milestone tracking, report
            generation and ticketing for tasks. I worked on milestone completion handling, multi-template
            project design and draft project lifecycle. The backend was built on a microservices
            architecture so each task is handled independently, with Jest test coverage across
            both frontend and backend.
        `,
        github: null,
        repoType: "private",
        livelink: ""
    },
    {
        projectname: "WorkCover Queensland (Contractual)",
        startDate: "02/11/2022",
        endData: "02/12/2023",
        techstacks: ['Spring-boot', 'Kafka', 'PostgreSql', 'JPA', 'REST APIs', 'Azure'],
        description: `
            Full-stack delivery for an Australian Government client, building microservices that connect
            Kafka, PostgreSQL and existing platform services, orchestrated locally with Tilt. The project was
            configuration-driven: controllers, entities and services are generated from Swagger definitions
            at service start-up and consumed across the other services.
        `,
        github: null,
        repoType: "private",
        livelink: ""
    },
    {
        projectname: "Nettverk",
        startDate: "02/09/2021",
        endData: null,
        techstacks: ['Spring-boot', 'ReactJs', 'SailPoint', 'Xero', 'WooCommerce', 'PostgreSql', 'GCP'],
        description: `
            A bi-directional data synchronization service integrating SailPoint, Xero and WooCommerce.
            It generates invoices, manages customers and procures reports on demand behind a custom-built
            interface. Records stay in sync across every connected system, removing manual data handling
            and improving reliability.
        `,
        github: null,
        repoType: "private",
        livelink: "https://app.nettverk.io"
    },
    {
        projectname: "Squarebear",
        startDate: "01/04/2020",
        endData: null,
        techstacks: ['Spring-boot', 'ReactJs', 'React Flow Renderer', 'Keycloak', 'ForgeRock OpenAM', 'PostgreSql', 'AWS'],
        description: `
            An advanced project management and delivery platform for designing application and business flows
            on a canvas and generating tickets against them. It supports workflow creation, Jira-style task
            boards, epics and journey mapping, plus problem statements and multiple personas with a canvas per
            persona. Access is secured with Keycloak and ForgeRock OpenAM, and the highly customizable kanban
            board supports live collaboration.
        `,
        github: null,
        repoType: "private",
        livelink: "https://app.squarebear.com.au"
    },
    {
        projectname: "Allianz — Identity Governance",
        startDate: null,
        endData: null,
        techstacks: ['One Identity', 'Angular', 'RBAC', 'OAuth2', 'OIDC', 'SAML'],
        description: `
            Enterprise identity governance for Allianz, delivered as a One Identity expert. I implemented
            role-based access control and user-lifecycle workflows, developed and enhanced the Angular web
            applications on top of them, and resolved complex system issues across the identity estate.
        `,
        github: null,
        repoType: "private",
        livelink: ""
    },
    {
        projectname: "Gigidy",
        startDate: null,
        endData: null,
        techstacks: ['Flutter', 'Dart', 'REST APIs'],
        description: `
            A restaurant job-matching mobile app built with Flutter, pairing candidates with venues through
            a sophisticated matching engine that scores availability, role fit and location.
        `,
        github: null,
        repoType: "private",
        livelink: ""
    },
    {
        projectname: "iVoyant (Contractual)",
        startDate: "01/05/2023",
        endData: "31/07/2023",
        techstacks: ['NodeJS', 'TypeScript', 'NextJs', 'Ant Design'],
        description: `
            A reusable, fully customizable decision-table component where every column and cell is
            configurable — consumers declare the type of each column and of each cell it holds. The table is
            split into three regions (When, Then, Annotations) that define which portion of the rule applies
            for which reason.
        `,
        github: null,
        repoType: "private",
        livelink: ""
    },
    {
        projectname: "Antooba Shop",
        startDate: "01/08/2018",
        endData: "01/03/2020",
        techstacks: ['ReactJs', 'Laravel', 'POS', 'Inventory', 'HRM', 'scss'],
        description: `
            An ERP solution that automates a shopkeeper's daily activity, built around three modules:<br/>
            1. Point-of-Sale (POS) for day-to-day selling<br/>
            2. Inventory Management for stock and suppliers<br/>
            3. HRM for staff, roles and payroll<br/>
            Laravel powers the API layer while a ReactJS frontend keeps the interface fast and responsive.
        `,
        github: "https://github.com/shahed-swe/antooba-dokan",
        repoType: "private",
        livelink: ""
    },
    {
        projectname: "SageSEO (Contractual)",
        startDate: "01/08/2022",
        endData: "31/10/2022",
        techstacks: ['VueJs', 'NuxtJs', 'VueX', 'Laravel', 'OpenAI', 'Core UI 3', 'GITLAB'],
        description: `
            A ChatGPT-powered AI content and keyword-generation platform for automated content writing,
            keyword research and publishing. I implemented the AI integration layer along with the admin and
            client interfaces in Vue.js and Nuxt.js, including generation of powerful titles from your content.
        `,
        github: null,
        repoType: "private",
        livelink: "https://app.sageseo.ai"
    }
]
